/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import "./Globalstyle.css";
import edMantra from "../../services/edMantra";
import MarketingAddLeads from "../../Components/EDLeadForm/MarketingAddLead";
import EDModal from "../../Components/EDModal/EDModal";
import { FaWhatsapp } from "react-icons/fa";
import { MdEdit, MdEmail } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MarketingEditLead from "../../Components/EDLeadForm/MarketingEditLead";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { FilterMatchMode } from "primereact/api";
import { FaAddressCard } from "react-icons/fa";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, {
  textFilter,
  dateFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import loadinggif from "../../assets/images/loading.gif";
import ToolkitProvider, {
  Search,
  CSVExport,
  pagination,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

const VendorsPipeline = (props) => {
  const { data } = useSelector((state) => state?.currentSession?.userInfo);
  const fileInputRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [allRemarks, setRemarks] = useState([]);
  const [leadObject, setLeadObject] = useState(null);
  const [allEmployees, setAllEmployees] = useState([]);
  const [leadData, setLeadData] = useState([]);

  const [editableRowIndex, setEditableRowIndex] = useState(null);
  const [file, setFile] = useState({});
  const [toggle, setToggle] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [totalLeads, setTotalLeads] = useState(0);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(50);

  const handleEditButtonClick = (lead) => {
    setLeadObject(lead);
    setRemarks(lead.remarks);
    setShowModal(true);
  };

  const fetchData = async (page = 1, limit = 50) => {
    setIsLoading(true);
    try {
      const response = await edMantra.getVendorsByEmpId(
        data?.empId,
        page,
        limit
      );
      const result = response.data;

      if (result && result.data) {
        setLeadData(result.data);
        setTotalLeads(result.totalCount || 0);
      } else {
        setLeadData([]);
        setTotalLeads(0);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setLeadData([]);
      setTotalLeads(0);
    } finally {
      setIsLoading(false);
    }
  };

  const pagination = paginationFactory({
    page,
    sizePerPage,
    totalSize: totalLeads,
    showTotal: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 },
    ],
    onPageChange: (newPage) => setPage(newPage),
    onSizePerPageChange: (newSize, newPage) => {
      setSizePerPage(newSize);
      setPage(newPage);
    },
  });

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const getAllEmployees = async () => {
    try {
      const allEmployees = await edMantra.getAllEmployees();
      setAllEmployees(allEmployees.data.data);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  const handleFileChange = (e, index) => {
    setFile(e.target.files[0]);
    setToggle(!toggle);
  };

  // Fetch employees once
  useEffect(() => {
    getAllEmployees();
  }, []);

  // Fetch leads when page/sizePerPage/refresh changes
  useEffect(() => {
    fetchData(page, sizePerPage);
  }, [page, sizePerPage, refresh]);

  const handleSave = async (val) => {
    try {
      const formData = new FormData();
      formData.append("lead_id", val.LeadId);
      formData.append("emp_id", data?.empId);
      const response = await edMantra.updateMarketingLeads(val.LeadId, {
        ...val,
        empId: data?.empId,
      });
      if (response.status === 200) {
      }
      setShowModal(false);
      toast(response.data.message);
      fetchData();
      setEditableRowIndex(null);
    } catch (error) {
      console.error(
        error.message || "An error occurred while updating the lead."
      );
    }
  };

  const openwhatsApp = async (phone) => {
    try {
      if (!phone.startsWith("+91")) {
        phone = "+91" + phone;
      }
      const whatsappUrl = `https://wa.me/${phone}`;
      window.open(whatsappUrl, "_blank");
    } catch (error) {
      console.error(error);
    }
  };

  const openEamil = (email) => {
    const recipient = email;
    const subject = "Subject of the email";
    const body = "Content of the email";
    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const handleAddlead = (params) => {
    setAddModal(true);
  };

  const formatDateforleadinout = (dateString) => {
    //for lead craetedAt and updatedAt
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Include this option for 12-hour format
    };
    return date.toLocaleDateString("en-GB", options);
  };

  const formatDatefornextfollow = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Include this option for 12-hour format
    };
    return date.toLocaleDateString("en-GB", options);
  };

  //---------------source filter option--------------------

  const leadSources = [
    { value: "", label: "Select a source" }, // Default option
    { value: "Website", label: "Website" },
    { value: "Facebook Ad", label: "Facebook Ad" },
    { value: "Instagram Ad", label: "Instagram Ad" },
    { value: "Google Ad", label: "Google Ad" },
    { value: "Just Dial", label: "Just Dial" },
    { value: "Walk-In", label: "Walk-In" },
    { value: "Incoming Call", label: "Incoming Call" },
    { value: "Reference", label: "Reference" },
    { value: "Alumni", label: "Alumni" },
    { value: "Field Data", label: "Field Data" },
    { value: "Seminar", label: "Seminar" },
    { value: "Webinar", label: "Webinar" },
    { value: "Schools", label: "Schools" },
    { value: "Coaching's", label: "Coaching's" },
    { value: "Event", label: "Event" },
    { value: "Activities", label: "Activities" },
    { value: "Admission Centre", label: "Admission Centre" },
    { value: "Franchise", label: "Franchise" },
    { value: "Self-Generated", label: "Self-Generated" },
    { value: "Employment Mantras", label: "Employment Mantras" },
    { value: "Purchased Data", label: "Purchased Data" },
    { value: "WhatsApp", label: "WhatsApp" },
    { value: "WhatsApp Status", label: "WhatsApp Status" },
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "GMB", label: "GMB" },
    { value: "WhatsApp Group", label: "WhatsApp Group" },
    { value: "Other", label: "Other" },
    { Value: "Google", label: "Google" },
  ];
  const leadSourceFilter = selectFilter({
    options: leadSources,
  });
  //-----------------------------------------------------------
  const filterByMultipleEducation = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedEducation = filterValue
      .split(",") // Split input by commas
      .map((pincode) => pincode.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedEducation.includes(row.pincode.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleCity = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedCity = filterValue
      .split(",") // Split input by commas
      .map((city) => city.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedCity.includes(row.city.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleLocation = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedLocation = filterValue
      .split(",") // Split input by commas
      .map((location) => location.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedLocation.includes(row.location.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleCP = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedCP = filterValue
      .split(",") // Split input by commas
      .map((objective) => objective.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedCP.includes(row.objective.toLowerCase()) // Check if row sector matches any selected industry
    );
  };

  const filterByMultipleStatus = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedStatus = filterValue
      .split(",") // Split input by commas
      .map((status) => status.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedStatus.includes(row.status.toLowerCase()) // Check if row sector matches any selected industry
    );
  };
  const filterByMultipleInterest = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedInterest = filterValue
      .split(",") // Split input by commas
      .map((interestLevel) => interestLevel.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter(
      (row) => selectedInterest.includes(row.interestLevel.toLowerCase()) // Check if row sector matches any selected industry
    );
  };
  const filterByMultipleLeadSource = (filterValue, data) => {
    if (!filterValue) return data; // If no filter, return all data

    const selectedLeadSource = filterValue
      .split(",") // Split input by commas
      .map((source) => source.trim().toLowerCase()); // Trim spaces & convert to lowercase for case-insensitive matching

    return data.filter((row) => {
      const source = row.source; // Access 'source' instead of 'leadSources'
      // Ensure leadSource is a non-empty string before processing
      return (
        typeof source === "string" &&
        selectedLeadSource.includes(source.toLowerCase())
      );
    });
  };

  // -----------data table--------------------------------------------
  const { ExportCSVButton } = CSVExport;
  const columns = [
    {
      dataField: "SrNo",
      text: "Sr. No",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "clientName",
      text: "Full Name",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "collegeCategory",
      text: "College Category",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "pocName",
      text: "Contact No.",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "pocMobile",
      text: "Contact No.",
      sort: "true",
      filter: textFilter(),
    },

    {
      dataField: "pocEmail",
      text: "Email",
      sort: "true",
      filter: textFilter(),
    },
    {
      dataField: "address",
      text: "Address",
      sort: "true",
      filter: textFilter(),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "location",
      text: "Location",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter Location (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleLocation(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "objective",
      text: "Objective",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter Objective (comma-separated)", // Guide the user
        onFilter: (filterValue, data) => filterByMultipleCP(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "interestLevel",
      text: "Interest Level",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter Interest Level (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleInterest(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },

    {
      dataField: "status",
      text: "Status",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter status (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleStatus(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "source",
      text: "Source",
      sort: "true",
      filter: textFilter({
        placeholder: "Enter status (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleLeadSource(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },

    {
      dataField: "preferredContactTiming",
      text: "Preferred Contact Timing",
      sort: "true",
      filter: textFilter(),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "nextfollow",
      text: "Next Follow Up Date",
      sort: "true",
      filter: dateFilter(),
      formatter: (cell, row) => formatDatefornextfollow(cell),
    },
    {
      dataField: "leadCreatedAt",
      text: "Create Time",
      sort: "true",
      filter: dateFilter(),
      formatter: (cell, row) => formatDateforleadinout(cell),
    },
    {
      dataField: "leadUpdatedAt",
      text: "Update Time",
      sort: "true",
      filter: dateFilter(),
      formatter: (cell, row) => formatDateforleadinout(cell),
    },
    {
      dataField: "telecaller",
      text: "Assign To",
      sort: "true",
      filter: selectFilter({
        options: allEmployees.map((emp) => ({
          value: emp.empId,
          label: `${emp.fname} ${emp.lname}`,
        })),
        placeholder: "Select or Search by Name",
      }),
      formatter: (cell, row) => {
        const telecaller = allEmployees?.find(
          (emp) => emp?.empId === row?.telecaller
        );
        if (telecaller) {
          return `${telecaller.fname} ${telecaller.lname}`;
        } else {
          return "Not Assigned"; // Or any other placeholder text
        }
      },
    },

    {
      dataField: "source",
      text: "Lead Source",
      sort: true,
      filter: textFilter({
        placeholder: "Enter Source (comma-separated)", // Guide the user
        onFilter: (filterValue, data) =>
          filterByMultipleLeadSource(filterValue, data),
      }),
      headerStyle: { minWidth: "120px" }, // Set minimum width
    },
    {
      dataField: "actions", // Assuming 'actions' is the field in your data object that contains the actions data
      text: "Actions",
      formatter: (cell, row, rowIndex, extraData) => {
        if (editableRowIndex === rowIndex) {
          return (
            <>
              <button
                className="btn btn-outline-primary me-2"
                onClick={() => handleSave(row.LeadId, rowIndex)}
              >
                Save
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={() => setEditableRowIndex(null)}
              >
                Cancel
              </button>
            </>
          );
        } else {
          return (
            <>
              <div className="d-flex">
                <div>
                  <div className="mx-2 pointer-cursor">
                    <MdEdit
                      size={20}
                      color="black"
                      onClick={() => handleEditButtonClick(row)}
                    />
                  </div>
                </div>
                {data?.role?.roleName === "SuperAdmin" && (
                  <div className="mx-2 pointer-cursor"></div>
                )}
              </div>
              <div className="d-flex">
                <div className="mx-2 pointer-cursor">
                  <FaWhatsapp
                    onClick={() => openwhatsApp(row?.mobile)}
                    size={20}
                    color="limegreen"
                  />
                </div>
                <div className="ms-2 pointer-cursor">
                  <MdEmail
                    style={{ cursor: "pointer" }}
                    onClick={() => openEamil(row.email)}
                    size={20}
                    color="#0072c6"
                  />
                </div>
              </div>
            </>
          );
        }
      },
    },
  ];

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    bgcolor: "red",
  };

  // Function to handle row selection
  const handleRowSelect = (row, isSelected) => {
    setSelectedRows([...selectedRows, row]);
  };
  console.log(selectedRows);

  // Function to handle row selection for all rows
  const handleRowSelectAll = (isSelected, rows) => {
    // Update selectedRows state when all rows are selected or deselected
    console.log(rows);
    if (isSelected) {
      setSelectedRows(rows);
    } else {
      setSelectedRows([]);
    }
  };
  //--------------data tabel--------------------------------------------

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 card border-0">
            <p className="fs-3 fw-normal typed-text">Vendor Leads Pipeline</p>
          </div>

          <div className="card col-md-4 col-sm-12 border-0">
            <div className="d-flex flex-wrap align-items-center">
              <>
                <button
                  type="button"
                  className="btn btn-warning btn-sm mr-2 mt-2"
                  onClick={() => handleAddlead()}
                >
                  <FaAddressCard color={"black"} size={20} /> Add New Lead
                </button>
              </>
            </div>
          </div>

          <div className=" card col-md-12 border-0">
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center">
                <img src={loadinggif} alt="Loading" />
              </div>
            ) : (
              <ToolkitProvider
                keyField="SrNo"
                data={leadData}
                columns={columns}
                exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                search
              >
                {(props) => (
                  <div>
                    <div className="table-responsive cus-table">
                      <BootstrapTable
                        filter={filterFactory()}
                        bootstrap4
                        keyField="SrNo"
                        data={leadData}
                        columns={columns}
                        striped
                        remote
                        hover
                        condensed
                        pagination={pagination}
                        onTableChange={handleTableChange}
                        filterPosition="top"
                        selectRow={{
                          mode: "checkbox",
                          clickToSelect: true,
                          selected: selectedRows.map((r) => r.SrNo),
                          onSelect: handleRowSelect,
                          onSelectAll: handleRowSelectAll,
                        }}
                      />
                    </div>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </div>

          <div className="card col-md-12 border-0">
            <div className="card bg-light m-2">
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <EDModal
                isOpen={showModal}
                handleClose={() => setShowModal(false)}
                size="xl"
              >
                <MarketingEditLead
                  handleSave={(obj) => handleSave(obj)}
                  leadObject={{ ...leadObject, remark: "" }}
                  allRemarks={allRemarks}
                />
              </EDModal>

              <EDModal
                isOpen={addModal}
                handleClose={() => setAddModal(false)}
                size="xl"
              >
                <MarketingAddLeads handleClose={(val) => setAddModal(false)} />
              </EDModal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorsPipeline;
